import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-secondary)";

export default function IconActivityScreenAdded({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M12 6.5a.5.5 0 0 1 0 1H9a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 1 1 0V16a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 16V8A1.5 1.5 0 0 1 9 6.5h3zm4 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5z"/>
        </svg>
    );
}
